export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7h-b97c7be8c7037863c858a760943f39da.webp";